var COOKIE_NAME = 'analytics_consent_response'

function getCookie(key) {
  document.cookie.split(";")
    .map(cookie => cookie.split("="))
    .find(([k, v]) => k.trim() == key)
}

function setCookie(key, value) {
  document.cookie = `${key}=${value};max-age=${60*60*24*365};path=/`
}

document.addEventListener("DOMContentLoaded", _ => {
  let consentPrompt = document.querySelector('#analytics-consent-prompt')
  if (consentPrompt) {
    consentPrompt.querySelector(`button[value="ALLOW"]`)
      .addEventListener('click', e => {
        setCookie(COOKIE_NAME, "ALLOW")
        consentPrompt.remove()
        let analyticsTemplate = document.querySelector(`template#analytics-block-template`)
        if (analyticsTemplate) {
          analyticsTemplate.parentNode.insertBefore(analyticsTemplate.content, analyticsTemplate)
          analyticsTemplate.remove()
        }
      })
    consentPrompt.querySelector(`button[value="DENY"]`)
      .addEventListener('click', e => {
        setCookie(COOKIE_NAME, "DENY")
        consentPrompt.remove()
      })
  }
})
